import type {PropsWithChildren} from 'react';
import {twMerge} from 'tailwind-merge';

import Typography from '@/components/base/Typography';

export type CardProps = Omit<React.HTMLAttributes<HTMLDivElement>, 'title'> & {
  className?: string;
  title?: string | JSX.Element;
  titleStyles?: string;
} & PropsWithChildren;

const Card = ({className, children, title, titleStyles, style, ...rest}: CardProps) => {
  return (
    <div
      className={twMerge('flex flex-col bg-base-color rounded-lg p-4 overflow-hidden shadow-md gap-4', className)}
      style={style}
      {...rest}>
      {title && (
        <Typography mode="bolder" className={twMerge('text-xl py-8 border-b border-base-200', titleStyles)}>
          {title}
        </Typography>
      )}
      {children}
    </div>
  );
};

export default Card;
